// extracted by mini-css-extract-plugin
export default {"root":"FilterColumn_root__TZBKG","title":"FilterColumn_title__0LNrg"};